














import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'page-layout',
  components: {}
})
export default class PageLayout extends Vue {
  @Prop({ type: String, default: '' })
  contentClass!: string

  @Prop({ type: Boolean, default: false })
  overlapped!: boolean
}
